import { memo } from 'react';

import PlansIconSVG from '@/assets/plans-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IPlansIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={PlansIconSVG} {...props} />;

export const PlansIcon = memo(IPlansIcon) as typeof IPlansIcon;
